import React from "react";
import { Box, Typography, CssBaseline, Button } from "@mui/material";
import { useHistory } from "react-router-dom";

export default function MobileGate() {
  const history = useHistory();
  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          minHeight: { xs: "100dvh", sm: "100vh" },
          width: "100%",
          bgcolor: "#0D0D0D",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          px: 3,
          gap: { xs: 2.5, sm: 4 },
          textAlign: "center",
        }}
      >
        {/* Logo */}
        <Box
          component="img"
          src="/Colloquia_Logo.png"
          alt="Colloquia"
          sx={{
            width: 120,
            borderRadius: "12px",
          }}
        />

        {/* Heading */}
        <Typography
          sx={{
            color: "#FFFDF8",
            fontSize: "1.75rem",
            fontWeight: 300,
            letterSpacing: "0.05em",
            lineHeight: 1.3,
          }}
        >
          Laptop or Desktop Only
        </Typography>

        {/* Subtext */}
        <Typography
          sx={{
            color: "#777",
            fontSize: "0.95rem",
            maxWidth: 320,
            lineHeight: 1.7,
          }}
        >
          This platform is designed for larger screens. Please visit us on a
          laptop or desktop computer for the full experience.
        </Typography>

        {/* Account creation note */}
        <Typography
          sx={{
            color: "#A8A8A8",
            fontSize: "0.9rem",
            fontStyle: "italic",
            letterSpacing: "0.02em",
            maxWidth: 300,
          }}
        >
          You may still create an account from your mobile device.
        </Typography>

        {/* Create account button */}
        <Button
          fullWidth
          variant="outlined"
          onClick={() => history.push("/register")}
          sx={{
            maxWidth: 280,
            py: 1.6,
            borderRadius: "12px",
            color: "#FFFDF8",
            borderColor: "#444",
            textTransform: "none",
            fontSize: "0.95rem",
            fontWeight: 300,
            letterSpacing: "0.04em",
            backgroundColor: "rgba(255,255,255,0.02)",

            "&:hover": {
              borderColor: "#777",
              backgroundColor: "rgba(255,255,255,0.05)",
            },
          }}
        >
          Create New Account
        </Button>

        {/* Divider accent */}
        <Box
          sx={{
            width: 40,
            height: 1,
            bgcolor: "#333",
          }}
        />

        {/* Footer brand */}
        <Typography sx={{ color: "#444", fontSize: "0.8rem" }}>
          © 2026 Colloquia from Penneferies Squire Capital
        </Typography>
      </Box>
    </>
  );
}